<template>
    <div class="card position-sticky top-1 mt-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">        
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#info">
            <i class="material-symbols-rounded text-lg me-2">person_pin_circle</i>
            <span class="text-sm">{{ $t('animal.Animal_info') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#arrival">
            <i class="material-symbols-rounded text-lg me-2">rv_hookup</i>
            <span class="text-sm">{{ $t('animal.Arrival') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#pedigree">
            <i class="material-symbols-rounded text-lg me-2">family_history</i>
            <span class="text-sm">{{ $t('animal.Pedigree') }}</span>
          </a>
        </li>     
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#keeper">
            <i class="material-symbols-rounded text-lg me-2">wash</i>
            <span class="text-sm">{{ $t('animal.Breed_keeper') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#studebook">
            <i class="material-symbols-rounded text-lg me-2">newsstand</i>
            <span class="text-sm">{{ $t('animal.Studebook') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#note">
            <i class="material-symbols-rounded text-lg me-2">article</i>
            <span class="text-sm">{{ $t('animal.Note') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#image">
            <i class="material-symbols-rounded text-lg me-2">image</i>
            <span class="text-sm">{{ $t('animal.Image') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#removal">
            <i class="material-symbols-rounded text-lg me-2">delete</i>
            <span class="text-sm">{{ $t('animal.Removal') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#studbookworthyness">
            <i class="material-symbols-rounded text-lg me-2">check</i>
            <span class="text-sm">{{ $t('animal.Studbookworthyness') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#exteriorpoints">
            <i class="material-symbols-rounded text-lg me-2">workspace_premium</i>
            <span class="text-sm">{{ $t('animal.Exterior_points') }}</span>
          </a>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "EditAnimalSideNav",
  };
  </script>
  